import {
  convertPoints,
  getResetOfPointsTransaction,
  getTransactionsAfterResetOfPoints,
  getTransactionsBeforeResetOfPoints,
} from './helpers'
import { NormalizedPointsHistory, PointsHistoryResponse } from './types'

export const normalizePointsHistory = ({
  totalNbrOfTransactions: totalNumberOfTransactions,
  transactions,
}: PointsHistoryResponse): NormalizedPointsHistory => {
  const transactionsWithConvertedPoints = convertPoints(transactions)
  const resetTransaction = getResetOfPointsTransaction(transactionsWithConvertedPoints)

  const transactionsAfterReset = getTransactionsAfterResetOfPoints(
    transactionsWithConvertedPoints,
    resetTransaction?.transactionDateAndTime,
  )
  const transactionsBeforeReset = getTransactionsBeforeResetOfPoints(
    transactionsWithConvertedPoints,
    resetTransaction?.transactionDateAndTime,
  )

  return {
    totalNumberOfTransactions,
    transactionsAfterReset,
    resetTransaction,
    transactionsBeforeReset,
  }
}
